export default {
  'show-list': 'Lista',
  'show-map': 'Mapa',
  'details': 'Detalles',
  'route-link': 'Ruta',
  'route-link.detail': 'Calcular ruta',
  'map': 'Mapa',
  'has-boxes': 'Venta de embalajes Hermes',
  'acceptsSuitcases': 'Entrega de equipaje',
  'back': 'atrás',

  'shoplist.info': {
    __html: 'Escribir un C. P., una localidad o calle para empezar la búsqueda en la zona.'
  },

  'shoplist.no-reroute-shops': 'No se han encontrado tiendas de paquetería cerca de la localidad indicada.',

  'business-hours.unknown': 'No hay información de horario de esta tienda de paquetería.',
  'business-hours.closed': 'Cerrado',

  'search': 'Buscar',
  'search.input-placeholder': 'Escribir dirección, C. P. o localidad',
  'search-criteria': 'Criterios de búsqueda',
  'search.toggle-details': 'Búsqueda detallada',
  'search-detail.intro': 'Las tiendas de paquetería mostradas pueden limitarse según estos criterios:',
  'search-detail.luggage.label': 'Entrega de equipaje',
  'search-detail.boxes.label': 'Venta de embalajes Hermes',
  'search-detail.apply': 'Utilizar filtro',
  'search-detail.close': 'Cerrar',

  'search-details.select-day.label': 'Día',
  'search-details.select-day.aria-label': 'Seleccionar día',
  'search-details.select-when.label': 'Cuándo',
  'search-details.select-when.aria-label': 'Seleccionar hora',
  'search-details.select-hour.label': 'Hora',
  'search-details.select-minute.label': 'Minuto',

  'search.icon-search.aria-label': 'Buscar',
  'search.icon-locate.aria-label': 'Usar ubicación',

  'error.no-shops': {
    __html: 'No se han encontrado tiendas de paquetería cerca de la localidad indicada.'
  },

  'error.address-resolve-failed': 'No se ha encontrado la dirección indicada.',
  'error.position-resolve-failed': 'No se ha encontrado la dirección indicada.',

  'days.short.MON': 'Lu',
  'days.short.TUE': 'Ma',
  'days.short.WED': 'Me',
  'days.short.THU': 'Ju',
  'days.short.FRI': 'Vi',
  'days.short.SAT': 'Sa',
  'days.short.SUN': 'Do',
  'days.full.MON': 'Lunes',
  'days.full.TUE': 'Martes',
  'days.full.WED': 'Miércoles',
  'days.full.THU': 'Jueves',
  'days.full.FRI': 'Viernes',
  'days.full.SAT': 'Sábado',
  'days.full.SUN': 'Domingo',
  'days.today': 'Hoy',
  'days.tomorrow': 'Mañana',

  'time.preposition.UNTIL': 'hasta las',
  'time.preposition.BEFORE': 'antes de las',

  //paketParcelLock
  'search.paketParcelLock.note': 'Please note: ',
  'search.paketParcelLock.link-text': 'how it works',
  'search.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  //paketParcelLock
  'details.benefits.paketParcelLock.list-1': 'Sending of parcels',
  'details.benefits.paketParcelLock.list-2': 'Online shop returns',
  'details.benefits.paketParcelLock.list-3': 'Send parcels fast and easy',
  'details.benefits.paketParcelLock.link-wrapper-text': 'For more Information please see ',
  'details.benefits.paketParcelLock.link-text': 'www.hamburgbox.de/faq',
  'details.benefits.paketParcelLock.link-url': 'http://www.hamburgbox.de/faq',

  //paketParcelLock
  'details.hint.paketParcelLock.headline': 'Important note:',
  'details.hint.paketParcelLock.copy': 'To be able to use this parcel station, a TAN is required to pick up the shipment.',
  'details.hint.paketParcelLock.link-text': ' How it works',
  'details.hint.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  // Media markkt
  'details.hint.parcel-shop.media-markt.copy': 'En este punto Hermes PaketShop solo es posible hacer envíos privados con una etiqueta pagada online (a través de myHermes.de o de la aplicación Hermes).',

  //paketParcelLock
  'callback-button.paketParcelLock.text': 'Select Paketstation',

  //paketParcelLock
  'details.title.paketParcelLock': 'Paketstation',

  'details.title': 'Tienda de paquetería Hermes',
  'details.opening-hours': 'Horario',
  'details.opening-hours-today': 'Horario de hoy',
  'details.parcelShopNumber': 'ID de tienda',

  'details.benefits.shipping': 'Envío de paquetes grandes y pequeños',
  'details.benefits.paketfuxx': 'Entrega a vecindad',
  'details.benefits.redirect': 'Dirección de entrega alternativa',
  'details.benefits.pickup': 'Recogida con autorización',
  'details.benefits.retours': 'Retorno de devoluciones de tienda online',

  'details.on-holiday.note': 'Atención:',
  'details.on-holiday': 'De %from a %to nuestra tienda está cerrada.',
  'details.on-holiday.short': 'Vacaciones: %from - %to',
  'services': 'Servicios',
  'callback-button.text': 'Escoger tienda de paquetería',
  'callback-button.unavailable': 'Lo sentimos. Esta tienda no puede escogerse.',

  'filter.luggage': 'Entrega de equipaje',
  'filter.boxes': 'Venta de embalajes Hermes',
  'filter.time': 'Abierto $day %time',
  'time-filter.at': 'a las',

  'time-filter.closed': 'Abre a las ',
  'time-filter.opened': 'Abierto hasta las ',
  'time-filter.from': ' y desde las ',
  'time-filter.openedNextDay': 'Abre el lunes ',
  'time-filter.openedFilter': 'Abierto ',

  'time-filter.openToday': 'Open today: ',
  'time-filter.clock': ' horas',

  'social-buttons.facebook': 'compartir',
  'social-buttons.twitter': 'tuitear',
  'social-buttons.whatsapp': 'compartir',
  'social-buttons.email': 'correo electrónico',
  'social-buttons.print': 'imprimir',

  'shop-list.title': 'Tiendas en la zona',
  'widget.headline': 'Buscar tiendas',
  'widget.input-placeholder': 'Dirección, C. P., localidad',
  'widget.option-button': 'Más opciones',
  'widget.submit-button': 'Buscar',
  'widget.open-on': 'Abierto el',

  'legal': 'Mentions légales',
  'security': 'Consignes de sécurité',
  'privacy': 'Protection des données',
  'cookies': 'Cookies',

  'legal.url': 'https://www.hermesworld.com/int/credits/',
  'security.url': 'https://www.hermesworld.com/int/security-advice/',
  'privacy.url': 'https://www.hermesworld.com/int/data-protection/',
  'cookies.url': '#uc-corner-modal-show',

  'cookie.text': 'This website uses cookies to analyse our traffic.',
  'cookie.button-text': 'Ok',
  'cookie.link-text': 'Learn more',
  'cookie.link-url': 'https://www.hermesworld.com/int/data-protection/',

  //UserCentrics Cookie Consent
  'usercentrics.info': 'Die Anzeige von PaketShops in der Nähe basiert auf Google Maps. Mit dem Klick auf "Karte aktivieren" stimme ich der Datenfreigabe an Google Maps zu.',
  'usercentrics.button': 'Karte aktivieren',
  'usercentrics.privacy-text': 'Datenschutz',
  'usercentrics.privacy-url': 'https://www.myhermes.de/datenschutz/',
  'usercentrics.impressum-text': 'Impressum',
  'usercentrics.impressum-url': 'https://www.myhermes.de/impressum/'
};
